require('../css/basics.css');
require('../css/nav.css');
require('../css/howto.css');
require('../css/contacts-box.css');
require('../css/footer.css');
require('./mobile-menu.js');

window.addEventListener('DOMContentLoaded', run);

async function run() {
    tabs();
    lazyLoadYoutube();
}

function tabs() {
    const slider = new Slider({
        parent: '.steps-wrapper',
        slideArea: '.tabs',
        slides: '.tab',
        navButtons: '.steps',
        navButton: 'li.button'
    });

    if (slider.isMobile()) {
        slider.slideToActiveButton();
    }

    document
        .querySelectorAll('.next-step-button')
        .forEach((btn) =>
            btn.addEventListener('click', (e) =>
                slider.slideTo(slider.activeIndex + 1)
            )
        );
}

function lazyLoadYoutube() {
    const videos = document.querySelectorAll('.youtube');

    for (var i = 0; i < videos.length; i++) {
        const video = videos[i];
        const source =
            'https://img.youtube.com/vi/' +
            video.dataset.ytid +
            '/sddefault.jpg';
        const image = new Image();
        image.src = source;
        image.alt = 'Youtube video';
        image.addEventListener(
            'load',
            (function () {
                video.appendChild(image);
            })(i)
        );

        video.addEventListener('click', function () {
            var iframe = document.createElement('iframe');

            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute(
                'src',
                'https://www.youtube-nocookie.com/embed/' +
                    this.dataset.ytid +
                    '?rel=0&showinfo=0&autoplay=1'
            );

            this.innerHTML = '';
            this.appendChild(iframe);
        });
    }
}

class Slider {
    constructor(params) {
        this.parent = document.querySelector(params.parent);
        this.slideArea = this.parent.querySelector(params.slideArea);
        this.slides = Array.from(this.parent.querySelectorAll(params.slides));
        this.navButtonsParent = this.parent.querySelector(params.navButtons);
        this.navButtons = this.navButtonsParent
            ? Array.from(
                  this.navButtonsParent.querySelectorAll(
                      params.navButton || 'a'
                  )
              )
            : [];
        this.activeIndex = 0;
        this.touchstartX = 0;
        this.touchstartY = 0;
        this.touchendX = 0;
        this.touchendY = 0;

        this.init();
    }

    init() {
        window.addEventListener('resize', (e) => this.slideToActiveButton());

        this.slideArea.addEventListener(
            'touchstart',
            (event) => {
                this.touchstartX = event.changedTouches[0].screenX;
                this.touchstartY = event.changedTouches[0].screenY;
            },
            false
        );

        this.slideArea.addEventListener(
            'touchend',
            (event) => {
                this.touchendX = event.changedTouches[0].screenX;
                this.touchendY = event.changedTouches[0].screenY;
                this.handleSwipe(event);
            },
            false
        );

        if (this.navButtonsParent) {
            this.navButtonsParent.addEventListener(
                'touchstart',
                (event) => {
                    this.touchstartX = event.changedTouches[0].screenX;
                    this.touchstartY = event.changedTouches[0].screenY;
                },
                false
            );

            this.navButtonsParent.addEventListener(
                'touchend',
                (event) => {
                    this.touchendX = event.changedTouches[0].screenX;
                    this.touchendY = event.changedTouches[0].screenY;
                    this.handleSwipe(event);
                },
                false
            );

            this.navButtons.forEach((item) => {
                function disablePointerEvents(children) {
                    for (let i = 0, ii = children.length; i < ii; i++) {
                        const child = children[i];
                        child.style.pointerEvents = 'none';
                        if (child.children.length) {
                            disablePointerEvents(child.children);
                        }
                    }
                }

                disablePointerEvents(item.children);

                item.addEventListener(
                    'click',
                    (e) => {
                        e.stopPropagation();
                        const idx = this.navButtons.indexOf(e.target);
                        this.slideTo(idx);
                        this.slideToActiveButton();
                    },
                    {}
                );
            });
        }
    }

    handleSwipe(event) {
        var caseCaptured = false;

        const { touchstartX, touchstartY, touchendX, touchendY } = this;

        if (touchendX < touchstartX && Math.abs(touchendX - touchstartX) > 30) {
            // Swipe left
            caseCaptured = true;
            if (this.activeIndex < this.slides.length - 1) {
                this.slideTo(this.activeIndex + 1);
                this.slideToActiveButton();
            }
        } else if (
            touchendX > touchstartX &&
            Math.abs(touchendX - touchstartX) > 30
        ) {
            // Swipe right
            caseCaptured = true;

            if (!this.activeIndex) {
                // If user swipes left and the slider is on the first image -> do nothing
                return;
            }

            this.slideTo(this.activeIndex - 1);
            this.slideToActiveButton();
        }

        if (caseCaptured) {
            event.preventDefault();
        }
    }

    slideTo(idx) {
        const reset = (item) => item.classList.remove('active');

        this.navButtons.forEach(reset);
        this.slides.forEach(reset);

        this.slides[idx] && this.slides[idx].classList.add('active');
        this.navButtons[idx] && this.navButtons[idx].classList.add('active');
        this.activeIndex = idx;
    }

    slideToActiveButton() {
        if (!this.navButtons.length) {
            return;
        }

        if (!this.isMobile()) {
            const firstButton = this.navButtons[0];
            firstButton.style.removeProperty
                ? firstButton.style.removeProperty('margin-left')
                : firstButton.style.removeAttribute('margin-left');
            return;
        }

        const { navButtonsParent, navButtons } = this;

        setTimeout(() => {
            const activeItem = navButtons.find((x) =>
                x.classList.contains('active')
            );

            console.log(navButtons);
            const activeIdx = navButtons.indexOf(activeItem);
            const activeItemW = activeItem.offsetWidth;
            const parentW = navButtonsParent.offsetWidth;

            console.log(parentW, activeItemW);

            const marginLeft =
                activeIdx === 0
                    ? (parentW / 2 - activeItemW / 2).toFixed()
                    : (function measureItemsBefore() {
                          let value = 0;
                          for (let i = 0; i < activeIdx; i++) {
                              value += navButtons[i].offsetWidth;
                          }

                          const margin = navButtons[activeIdx]
                              .nextElementSibling
                              ? navButtons[activeIdx].nextElementSibling
                                    .clientWidth
                              : 0;
                          console.log(margin);
                          const itemsWidth = value + margin * (activeIdx - 1);
                          const parentWidth = navButtonsParent.offsetWidth / 2;
                          const x = parentWidth - (margin + activeItemW / 2);

                          return -(itemsWidth - x);
                      })();

            navButtons[0].style.marginLeft = marginLeft + 'px';
        }, 50);
    }

    isMobile() {
        const detector = document.querySelector('.mobile-detector');
        const styles = window.getComputedStyle(detector);
        return styles.getPropertyValue('display') === 'none';
    }
}
